<!--头部导航条-->
<template>
  <div class="header-component">
    <div class="logo-bag">
      <div class="version-center flex">
        <router-link to="/home" class="logo-container">
          <img src="../assets/images/6_transparent.png" alt="" />
          <div class="logo-text">
            <h1>广西壮族自治区医疗器械检测中心</h1>
            <p>Guangxi Testing Center for Medical Devices</p>
          </div>
        </router-link>
      </div>
    </div>
    <div style="height: 60px; width: 100%" v-show="isSticky"></div>
    <div
      class="headernav"
      :style="isSticky ? 'position: fixed;top:0 ;' : 'position: static'"
    >
      <div class="version-center flex">
        <div
          class="menu"
          :class="{
            'active':
              $route.path == '/home' ||
              $route.query.title == '首页' ||
              $route.path == '/'
          }"
          @click="() => $router.push('/home')"
        >
          <img src="../assets/images/navigation_icon_01.webp" alt="" /> 首页
        </div>
        <div v-for="(item, i) in menuArr" :key="i">
          <el-popover
            :visible-arrow="false"
            trigger="hover"
            popper-class="menu-children-item"
          >
            <!-- 公众服务定制布局 -->
            <div class="flex is-grouping" v-if="item.isGrouping">
              <div class="flex">
                <p class="title">在线服务</p>
                <p
                  v-for="(childrenItem, childrenI) in item.grouping1"
                  :key="childrenI"
                  @click="onMenuLinkItem(childrenItem.url)"
                  :class="{
                    'document-active': childrenItem.tag == $route.query.tag
                  }"
                >
                  {{ childrenItem.tag }}
                </p>
              </div>
              <div class="flex">
                <p class="title">办事指南</p>
                <p
                  v-for="(childrenItem, childrenI) in item.grouping2.filter(item => item.tag !== '承检能力')"
                  :key="childrenI"
                  @click="
                    onMenuItem(
                      {
                        path: '/document',
                        children: item.grouping2,
                        title: '公众服务'
                      },
                      childrenItem
                    )
                  "
                  :class="{
                    'document-active': childrenItem.tag == $route.query.tag
                  }"
                >
                  {{ childrenItem.tag }}
                </p>
              </div>

              <div class="flex">
                <p class="title">公正性声明</p>
                <p
                  v-for="(childrenItem, childrenI) in item.children"
                  :key="childrenI"
                  @click="onMenuItem(item, childrenItem)"
                  :class="{
                    'document-active': childrenItem.tag == $route.query.tag
                  }"
                >
                  {{ childrenItem.tag }}
                </p>
              </div>
            </div>
            <!-- 正常菜单 -->
            <div class="flex ul" v-else>
              <div
                class="li"
                v-for="(childrenItem, childrenI) in item.children"
                :key="childrenI"
                @click="onMenuItem(item, childrenItem)"
                :class="{
                  'active': childrenItem.tag == $route.query.tag
                }"
              >
                {{ childrenItem.tag }}
              </div>
            </div>

            <div
              slot="reference"
              class="menu textmenu"
              @click="onMenu(item)"
              :class="{
                'active': $route.query.title == item.title
              }"
            >
              <img :src="item.icon" alt="" />
              {{ item.title }}
            </div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getKey } from '@/api/index'

export default {
  components: {},
  data() {
    return {
      title: '首页',
      menuArr: [
        {
          title: '机构概况',
          path: '/institutional-overview',
          isGrouping: false,
          icon: require('../assets/images/navigation_icon_02.webp'),
          children: [
            { tag: '中心概况', hash: 'tab1' },
            { tag: '承检能力', hash: 'tab5' },
            { tag: '科室职能', hash: 'tab2' },
            { tag: '中心领导', hash: 'tab3' },
            { tag: '联系方式', hash: 'tab4' }
          ]
        },
        {
          title: '中心动态',
          path: '/document',
          isGrouping: false,
          icon: require('../assets/images/navigation_icon_03.webp'),
          children: []
        },

        {
          title: '器检党建',
          path: '/party-building',
          isGrouping: false,
          icon: require('../assets/images/navigation_icon_04.webp'),
          children: [{ tag: '党建动态', key: 'party.building.news' }]
        },
        {
          title: '法规文件',
          isGrouping: false,
          path: '/document',
          icon: require('../assets/images/navigation_icon_05.webp'),
          children: [
            { tag: '法规', key: 'regulatory.provision.id' },
            { tag: '部门规章', key: 'regulatory.department.id' },
            { tag: '公告', key: 'regulatory.notice.id' },
            { tag: '指南', key: 'regulatory.guide.id' },
            { tag: '征求意见稿', key: 'regulatory.opinion.id' }
          ]
        },
        {
          title: '公众服务',
          path: '/office-hall',
          isGrouping: true,
          icon: require('../assets/images/navigation_icon_06.webp'),
          children: [
            { tag: '质量方针', key: 562, hash: 'section4', to: 500, left: 0 },
            { tag: '公正性声明', key: 559, hash: 'section1', to: 500, left: 160 },
            {
              tag: '诚信检验检测承诺书',
              key: 930,
              hash: 'section1',
              to: 500,
              left: 310
            },
            { tag: '资质证书', key: 560, hash: 'section2', to: 500, left: 570 },
            { tag: '检验能力', hash: 'section3', to: 500, left: 730 }
          ],
          // 注意:修改这里的任何一个地址,都要同步修改src\views\home.vue 的相同地址
          grouping1: [
            {
              tag: '客户服务平台',
              url: 'http://116.252.25.141:8901/workspaces'
            },
            {
              tag: '大型仪器设备共享平台',
              url: 'http://222.216.37.168:8086/mylims/resource/sunway/dxyqgx.jsp?url=/mylims/'
            }
          ],
          grouping2: []
        }
      ],
      isSticky: false
    }
  },
  watch: {
    '$route.query.title': {
      handler(val) {
        this.tag = val
        this.menuArr.forEach((item) => {
          if (item.title == val) {
            this.$store.commit('SET_TABS', item)
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  computed: {},
  methods: {
    onMenu(item) {
      this.$router.push({
        path: item.path,
        query: {
          title: item.title,
          tag: item.children[0].tag,
          key: item.children[0].key
        }
      })
      this.$store.commit('SET_TABS', item)
    },
    // 跳转本地
    onMenuItem(item, { tag, key, to, hash }) {
      this.$router.push({
        path: item.path,
        query: { title: item.title, tag, key, hash }
      })
      if (to) {
        setTimeout(function () {
          window.scrollTo(0, to)
        }, 200)
      }
      this.$store.commit('SET_TABS', item)
    },
    // 跳转第三方链接
    onMenuLinkItem(url) {
      window.open(url, '_blank')
    },
    // 粘性定位
    handleScroll() {
      if (window.scrollY >= 180) {
        this.isSticky = true
      } else if (window.scrollY <= 180) {
        this.isSticky = false
      }
    },
    getKey() {
      getKey({ key: 'service.id' })
        .then((res) => {
          this.menuArr.forEach((item) => {
            if (item.title == '公众服务') {
              item.grouping2 = res.children.map((item) => {
                return { tag: item.name, key: item.configKey }
              })
            }
          })
        })
        .finally(() => {})
      getKey({ key: 'news.id' })
        .then((res) => {
          this.menuArr.forEach((item) => {
            if (item.title == '中心动态') {
              item.children = res.children.map((item) => {
                return { tag: item.name, key: item.configKey }
              })
            }
          })
        })
        .finally(() => {})
    }
  },
  mounted() {
    this.$store.commit('SET_MENUARR_TAB', this.menuArr)
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    this.$nextTick(() => this.getKey())
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang="scss" scoped>
.header-component {
  min-width: 100%;
  line-height: 40px;
  .logo-bag {
    background: url(../assets/images/header-bag.webp) no-repeat;
    background-size: cover;
    object-fit: fill;
    height: 180px;
    img {
      height: 110px;
    }
    .logo-container {
      display: flex;
      align-items: center;
      text-decoration: none;
      
      .logo-text {
        margin-left: 20px;
       
        h1 {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 800;
          font-size: 35px;
          color: #1653A2;
          line-height: 56px;
        }
        
        p {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 21px;
          color: #1653A2;
          line-height: 37px;
          letter-spacing: 2px;
        }
      }
    }
  }
  .version-center {
    height: 100%;
    align-items: center;
    .menu {
      height: 60px;
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 60px;
      color: #fff;
      font-weight: bold;
      font-size: 24px;
      position: relative;
      z-index: 1;
      cursor: pointer;

      img {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
    }
    .active {
      background: linear-gradient(180deg, #8bc8ff 0%, #3f9cff 100%);
      top: 0px;
      height: 76px;
      background: url(../assets/images/title_bag_1.webp) no-repeat;
      background-size: 200px 84px;
      background-position: 0px -4px;
    }
    .textmenu {
      &::before {
        left: -43px;
      }
      &::after {
        left: 43px;
      }
    }
  }

  .headernav {
    border-top: 30px solid #3279d6;
    border-bottom: 30px solid #1b6ad2;
    background: linear-gradient(180deg, #176bc4 0%, #14579e 100%);
    background-size: cover;
    object-fit: fill;
    height: 0px;
    z-index: 100;
    width: calc(100vw - 6px);
    top: 0;
    position: static;
    // position: fixed;
  }
} //
</style>
<style>
.menu-children-item {
  border-radius: 0px !important;
  padding: 0px !important;
  margin-top: 0 !important;
  max-width: 900px !important;
  > .ul {
    max-width: max-content;
    flex-wrap: wrap;
    .li {
      height: 60px;
      width: 149px;
      font-size: 18px;
      margin-bottom: 2px;
      cursor: pointer;
      line-height: 60px;
      padding: 0 0 0 34px;
      min-width: 100px;
      flex: 1;
      color: #14579e;
      font-weight: bold;
    }
    .title {
      width: 90px;
    }
  }
  .active {
    color: #fff !important;
    font-weight: bold;
    background: url(../assets/images/back_4.webp) no-repeat;
    background-size: 100% 100%;
  }
  .document-active {
    color: #14579e;
    font-weight: bold;
  }
  .is-grouping {
    flex-direction: column;
    p {
      line-height: 52px;
      margin-right: 16px;
      max-width: 192px;
      font-size: 18px;
      cursor: pointer;
      font-weight: bold;
      &:hover {
        color: #14579e;
        font-weight: bold;
      }
    }

    .title {
      font-weight: bold;
      color: #fff;
      min-width: 192px;
      position: relative;
      background: url(../assets/images/tab_selecte.webp) no-repeat;
      background-size: 100% 100%;
      font-size: 22px;
      text-align: left;
      padding-left: 36px;
      cursor: auto;
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>
